import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/")({
  component: SettingsIndexPage,
});

function SettingsIndexPage() {
  return <Navigate to="/settings/account/$" />;
}
